export default {"buttonWrapper":"_buttonWrapper_xid7n_1"};